function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "io");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "io",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M10,15.3445414 C10,12.3928423 12.4613357,10 15.4975252,10 C15.4989394,10 15.5007071,10 15.5024748,10 C18.5386643,10 21,12.3928423 21,15.3445414 C21,24.3893614 21,42.6106386 21,51.6554586 C21,54.6071577 18.5386643,57 15.5024748,57 C15.5007071,57 15.4989394,57 15.4975252,57 C12.4613357,57 10,54.6071577 10,51.6554586 C10,42.6106386 10,24.3893614 10,15.3445414 Z",
  id: "neutral",
  fillOpacity: 0.4,
  fill: "#303030"
}), React.createElement("path", {
  d: "M24.2725655,0 C37.1172433,0 47.5454545,10.4279602 47.5454545,23.2727273 C47.5454545,36.1174943 37.1172433,46.5454545 24.2725655,46.5454545 C11.4282113,46.5454545 1,36.1174943 1,23.2727273 C1,10.4279602 11.4282113,0 24.2725655,0 Z",
  id: "secondary",
  fillOpacity: 0.2,
  fill: "#303030"
}), React.createElement("path", {
  d: "M59.5,57 C54.6616593,57 50.3006702,55.9829488 46.4170326,53.9488465 C42.5330483,51.9147441 39.4928357,49.1126988 37.2957014,45.5420346 C35.0985671,41.9717084 34,37.9575842 34,33.5 C34,29.0424158 35.0985671,25.0282916 37.2957014,21.4579654 C39.4928357,17.8876392 42.5330483,15.0852559 46.4170326,13.0511535 C50.3006702,11.0170512 54.6616593,10 59.5,10 C64.337994,10 68.68789,11.0170512 72.549688,13.0511535 C76.4111394,15.0852559 79.4516986,17.8876392 81.6710192,21.4579654 C83.8903397,25.0282916 85,29.0424158 85,33.5 C85,37.9575842 83.8903397,41.9717084 81.6710192,45.5420346 C79.4516986,49.1126988 76.4111394,51.9147441 72.549688,53.9488465 C68.68789,55.9829488 64.337994,57 59.5,57 Z M59.5,48.0415672 C62.2517911,48.0415672 64.7376936,47.4247116 66.9570141,46.1913385 C69.1763346,44.9579654 70.9183037,43.2375298 72.1832679,41.0303699 C73.448232,38.82321 74.0808875,36.3131994 74.0808875,33.5 C74.0808875,30.6868006 73.448232,28.17679 72.1832679,25.9696301 C70.9183037,23.7624702 69.1763346,22.0420346 66.9570141,20.8086615 C64.7376936,19.5752884 62.2517911,18.9587708 59.5,18.9587708 C56.7478623,18.9587708 54.2623064,19.5752884 52.0429859,20.8086615 C49.8236654,22.0420346 48.0813497,23.7624702 46.8163855,25.9696301 C45.5514213,28.17679 44.9191125,30.6868006 44.9191125,33.5 C44.9191125,36.3131994 45.5514213,38.82321 46.8163855,41.0303699 C48.0813497,43.2375298 49.8236654,44.9579654 52.0429859,46.1913385 C54.2623064,47.4247116 56.7478623,48.0415672 59.5,48.0415672 Z",
  id: "primary",
  fill: "#303030"
}));

var SvgIo = function SvgIo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "96px",
    height: "64px",
    viewBox: "0 0 96 64",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/io.72936da0.svg";
export { ForwardRef as ReactComponent };